export default `
-- AlterTable
ALTER TABLE "Project" ADD COLUMN "parent_id" TEXT;
ALTER TABLE "Project" ADD COLUMN "project_ancestry" TEXT;

-- CreateIndex
CREATE INDEX "Project_parent_id_idx" ON "Project"("parent_id");

-- CreateIndex
CREATE INDEX "Project_project_ancestry_idx" ON "Project"("project_ancestry");
`;
